import _ from 'lodash';

import { LoanApplicationTabName } from 'constants/loanApplication';

import { BORROWING_ENTITY_TABS_HREF } from '../../tabs/borrowers/EditEntityModal/EditEntityModal.constants';

export const BORROWERS_TAB_NAME = LoanApplicationTabName.BORROWERS;
export const BORROWERS_TAB_ROUTE = _.kebabCase(BORROWERS_TAB_NAME);

const BorrowerSectionLabelOverride = {
  [BORROWING_ENTITY_TABS_HREF.BORROWER]: 'Personal Info',
  [BORROWING_ENTITY_TABS_HREF.POA]: 'POA',
};

export const BorrowerSectionName = Object.fromEntries(
  Object.values(BORROWING_ENTITY_TABS_HREF).map(href => [
    href,
    BorrowerSectionLabelOverride[href] ?? _.startCase(href),
  ]),
);

export const LOAN_CLOSING_TAB_NAME = LoanApplicationTabName.CLOSING_NEW;
export const LOAN_CLOSING_TAB_ROUTE = _.kebabCase(LOAN_CLOSING_TAB_NAME);

export const DOCUMENTS_TAB_ROUTE = _.kebabCase(LoanApplicationTabName.DOCUMENTS);

export const UNDERWRITING_TAB_ROUTE = _.kebabCase(LoanApplicationTabName.UNDERWRITING);
export const CONTACTS_TAB_NAME = LoanApplicationTabName.CONTACTS;
export const CONTACTS_TAB_ROUTE = _.kebabCase(CONTACTS_TAB_NAME);

export const ALERTS_TAB_ROUTE = 'alerts';

export const CONDITION_MESSAGE_PREVIEW_LENGTH = 80;

export const DUMMY_ENTITY_ID = 'search';

const ClosingSectionNavName = [
  { sectionHref: 'closing-information', label: 'Closing Information' },
  { sectionHref: 'funding-information', label: 'Funding Information' },
];

export const LoanClosingSectionName = Object.fromEntries(
  ClosingSectionNavName.map(({ sectionHref, label }) => [sectionHref, label]),
);
